const $6bcee6a4989673ce$var$nuffleSqueakDuration = 200;
let $6bcee6a4989673ce$var$nuffleSqueakTimeout = 0;
const $6bcee6a4989673ce$var$onload = ()=>{
    const nuffle = document.getElementById("nuffle-squeaker");
    if (nuffle) {
        const sqek = document.getElementById("sqek");
        const nuffleSqueaked = document.getElementById("nuffle-squeaked");
        const nuffleUnsqueaked = document.getElementById("nuffle-unsqueaked");
        const doSqueak = ()=>{
            if (sqek) sqek.play().catch((error)=>{
                console.error("Error playing sound:", error);
            });
            if (!nuffleSqueaked || !nuffleUnsqueaked) return;
            nuffleUnsqueaked.classList.add("d-none");
            nuffleSqueaked.classList.remove("d-none");
            $6bcee6a4989673ce$var$nuffleSqueakTimeout = Date.now() + $6bcee6a4989673ce$var$nuffleSqueakDuration;
            setTimeout(()=>{
                if (Date.now() < $6bcee6a4989673ce$var$nuffleSqueakTimeout) return;
                nuffleSqueaked.classList.add("d-none");
                nuffleUnsqueaked.classList.remove("d-none");
            }, $6bcee6a4989673ce$var$nuffleSqueakDuration);
        };
        nuffle.onclick = doSqueak;
    }
};
if (document) document.addEventListener("DOMContentLoaded", $6bcee6a4989673ce$var$onload);


//# sourceMappingURL=about.564ebdde.js.map
